import { useTranslation } from 'react-i18next'

export const localDayNumber = (ms = Date.now()) =>
  Math.floor((ms - new Date(ms).getTimezoneOffset() * 60_000) / 86_400_000)

// Short, signed lines from the team, shown now and then. Index 0 is the gratitude line.
export function useHumanTouch() {
  const { t } = useTranslation()
  const raw = t('humanTouch.lines', { returnObjects: true }) as unknown
  const lines = Array.isArray(raw) ? (raw as string[]) : []
  return {
    count: lines.length,
    line: (i: number) =>
      lines.length ? t('humanTouch.signed', { line: lines[Math.abs(i) % lines.length] }) : '',
  }
}
